// src/viewmodel/adapters/typebox.ts
function createTypeBoxAdapter(typeBoxSchema, entityPrefix, options) {
  const properties = typeBoxSchema.properties;
  const toAtPath = options?.toAtPath ?? ((prefix, name) => `${prefix}/${name}`);
  const attributeDefs = Object.entries(properties).map(([name, propSchema]) => {
    const isOptional = propSchema.optional ?? false;
    const wovinAtName = propSchema.wovinAtName;
    const atPath = options?.atOverrides?.[name] ?? wovinAtName ?? toAtPath(entityPrefix, name);
    return {
      name,
      atPath,
      optional: isOptional,
      defaultValue: propSchema.default
    };
  });
  return {
    getAttributeDefs: () => attributeDefs,
    getDefaults: () => options?.defaults ?? {},
    getEntityPrefix: () => entityPrefix,
    createValidator: options?.validator ? () => options.validator : void 0
  };
}

export {
  createTypeBoxAdapter
};
//# sourceMappingURL=chunk-ICBK7NC4.js.map